import styled from 'styled-components';

import { MenuItem as _MenuItem } from '@mui/material';

export const MenuItem = styled(_MenuItem)`
  letter-spacing: 0.15px;
  color: ${({ theme }) => theme.yoga.colors.text.primary};
`;
